var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgDynamics365Logo = function SvgDynamics365Logo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dynamics365-logo_svg__a)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "dynamics365-logo_svg__c",
    x1: 38.045,
    y1: -1,
    x2: 56.658,
    y2: 47.723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B53CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7252AA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dynamics365-logo_svg__f",
    x1: 64.138,
    y1: 93.492,
    x2: 64.138,
    y2: 35.415,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2266E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE7FE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dynamics365-logo_svg__g",
    x1: 82,
    y1: 56.786,
    x2: 62.076,
    y2: 56.786,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#94B9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.288,
    stopColor: "#94B9FF",
    stopOpacity: 0.524
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#538FFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("filter", {
    id: "dynamics365-logo_svg__d"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.4,
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "dynamics365-logo_svg__e"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dynamics365-logo_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h96v96H0z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "dynamics365-logo_svg__b",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 70,
    height: 96
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82 31.047a10 10 0 0 0-6.637-9.417L17.345.909C14.74-.021 12 1.909 12 4.676v31.505a4 4 0 0 0 2.655 3.767l26 9.286c2.605.93 5.345-1.001 5.345-3.767v-18.09a2 2 0 0 1 2.704-1.872l6.818 2.566A10 10 0 0 1 62 37.43v7.878L32.627 56.04A4 4 0 0 0 30 59.797V91.28c0 2.778 2.763 4.71 5.373 3.757L75.432 80.4A10 10 0 0 0 82 71.007v-39.96Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#dynamics365-logo_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m12-1 70 25v34.325c0 2.765-2.74 4.697-5.345 3.767L62 56.859V37.424a10 10 0 0 0-6.483-9.361l-6.814-2.56A2 2 0 0 0 46 27.375v23.768L12 39V-1Z",
    fill: "url(#dynamics365-logo_svg__c)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#dynamics365-logo_svg__d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82 31.4c0 4.2-2.624 7.959-6.568 9.4L30 57.4v40l52-19v-47Z",
    fill: "#000",
    fillOpacity: 0.24
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#dynamics365-logo_svg__e)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82 33c0 4.2-2.624 7.959-6.568 9.4L30 59v40l52-19V33Z",
    fill: "#000",
    fillOpacity: 0.32
  })), /*#__PURE__*/React.createElement("path", {
    d: "M82 31c0 4.2-2.624 7.959-6.568 9.4L30 57v40l52-19V31Z",
    fill: "url(#dynamics365-logo_svg__f)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M82 31c0 4.2-2.624 7.959-6.568 9.4L30 57v40l52-19V31Z",
    fill: "url(#dynamics365-logo_svg__g)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "m62.001 45.32-16.009 5.857v23.458a2 2 0 0 0 2.705 1.872l6.827-2.57a10 10 0 0 0 6.477-9.36V45.32Z",
    fill: "#B0ADFF"
  })))));
};

export default SvgDynamics365Logo;